import initPage from "../../utils/initPage";
import t from "../../i18n/i18n";

import Template from "../../template/template";
import Aside from "./aside/aside";
import PasswordForm from "./passwordForm/passwordForm";

function ChangePassword() {
  initPage({ title: t("Profile.PasswordChangeTitle") });

  return (
    <Template>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="inside-warp">
              <div className="col-sidebar">
                <div className="mobile-side-btn">
                  <button type="button" className="side-toggle">
                    <i className="fal fa-cog"></i>
                  </button>
                </div>
                <div className="sidebar-main">
                  <Aside />
                </div>
              </div>

              <div className="col-contentbar">
                <div className="user-profile-form change-password">
                  <PasswordForm />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Template>
  );
}

export default ChangePassword;
